import PropTypes from 'prop-types';
import { widthPropType, heightPropType, aspectRatioPropType } from './common_types';

export const ElementSizePolicyType = {
  FIXED_ASPECT_RATIO: 1,
  VARIABLE_ASPECT_RATIO: 2,
  FULLY_SPECIFIED: 3
};

const fixedAspectRatioPolicyPropType = PropTypes.shape({
  type: PropTypes.oneOf([ElementSizePolicyType.FIXED_ASPECT_RATIO]).isRequired,
  widths: PropTypes.objectOf(widthPropType.isRequired).isRequired,
  aspectRatio: aspectRatioPropType.isRequired
});

const variableAspectRatioPolicyPropType = PropTypes.shape({
  type: PropTypes.oneOf([ElementSizePolicyType.VARIABLE_ASPECT_RATIO]).isRequired,
  widths: PropTypes.objectOf(widthPropType.isRequired).isRequired,
  aspectRatios: PropTypes.objectOf(aspectRatioPropType.isRequired).isRequired
});

const fullySpecifiedPolicyPropType = PropTypes.shape({
  type: PropTypes.oneOf([ElementSizePolicyType.FULLY_SPECIFIED]).isRequired,
  widths: PropTypes.objectOf(widthPropType.isRequired).isRequired,
  heights: PropTypes.objectOf(heightPropType.isRequired).isRequired
});

export const elementSizePolicyPropType = PropTypes.oneOfType([
  fixedAspectRatioPolicyPropType,
  variableAspectRatioPolicyPropType,
  fullySpecifiedPolicyPropType
]);
